// Static values for the PayNow QR flow (button, generation, display, polling).

export const PAYNOW_DEFAULTS = {
  PROXY_TYPE: process.env.REACT_APP_PAYNOW_PROXY_TYPE || "2",
  PROXY_VALUE: process.env.REACT_APP_PAYNOW_PROXY_VALUE || "201234567M",
  MERCHANT_NAME: "Merchant",
};

// PayNow references only allow alphanumerics, max 25 chars.
export const PAYNOW_REFERENCE = {
  SANITIZE_REGEX: /[^A-Za-z0-9]/g,
  MAX_LENGTH: 25,
};

export const PAYNOW_TIMER = {
  SCAN_SECONDS: parseInt(process.env.REACT_APP_PAYNOW_SCAN_SECONDS || "300"),
  STATUS_POLL_MS: parseInt(process.env.REACT_APP_PAYNOW_STATUS_POLL_MS || "3000"),
  URGENT_THRESHOLD_SECONDS: 10,
};

// Both spellings are returned by the status API.
export const PAYNOW_TRANSACTION_STATUS = {
  SUCCESS: ["SUCCESSFUL", "SUCCESSFULL"],
  FAILURE: ["NOTSUCCESSFUL", "NOTSUCCESSFULL"],
};

export const PAYNOW_AMOUNT_POPUP = {
  LOGO: "/cards/sgd-amount.png",
  TYPE: "paynow",
};
